import { BarChart, Bar, LabelList, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import InfoTip from "./InfoTip";
import { VerticalCursor, TipBox } from "./FlowChart";
import { money, pct, k, niceMax, ticksTo, COLORS } from "./metricsMath";

const CovTip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const r = payload[0].payload;
  return <TipBox testid="coverage-tooltip" title={r.mesLargo} lines={[[null, "Salió", money(r.salio)], [COLORS.gas, "Gasto registrado", money(r.gastos)], [COLORS.sin, "Sin registrar", money(Math.max(0, r.sin))], [null, "Registrado", pct(r.pctRegistrado)]]} />;
};

const PctLabel = ({ x, y, width, index, rows }) => {
  const r = rows[index];
  if (!r || r.pctRegistrado == null) return null;
  return <text x={x + width / 2} y={y - 6} textAnchor="middle" fontSize={11} fontWeight={700} fill="#18181b" data-testid={`coverage-label-${r.month}`}>{pct(r.pctRegistrado, 0)}</text>;
};

// Cada barra = todo lo que salió del banco: naranja con gasto registrado, gris sin registrar.
export default function CoverageChart({ rows, sinTotal }) {
  const data = rows.map((r) => ({ ...r, gastosClamp: Math.min(r.gastos, r.salio), sinPos: Math.max(0, r.sin) }));
  const top = niceMax(Math.max(0, ...rows.map((r) => r.salio || 0)));
  return (
    <section className="border border-zinc-200 bg-white rounded-lg p-5 flex flex-col gap-2 min-w-0" data-testid="coverage-section">
      <h3 className="font-heading font-bold text-base m-0 inline-flex items-center gap-1.5">Salidas registradas como gasto <InfoTip k="coverage" /></h3>
      <p className="text-xs text-zinc-500 m-0 leading-relaxed">Cada barra es todo lo que salió del banco: la parte naranja tiene gasto registrado y la gris no. En el año, <b className="text-zinc-900 numeric" data-testid="coverage-unregistered">{money(Math.max(0, sinTotal))}</b> salieron sin un gasto que lo explique.</p>
      <div className="flex flex-wrap gap-4 text-xs text-zinc-500">
        <span className="inline-flex items-center gap-1.5"><i className="w-2.5 h-2.5 rounded-sm inline-block" style={{ background: COLORS.gas }} />Gasto registrado <InfoTip k="expenses" /></span>
        <span className="inline-flex items-center gap-1.5"><i className="w-2.5 h-2.5 rounded-sm inline-block" style={{ background: COLORS.sin }} />Salida sin registrar <InfoTip k="unregistered" /></span>
      </div>
      <div className="h-[240px]" data-testid="coverage-chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 18, right: 8, left: 0, bottom: 0 }} barCategoryGap="35%">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0eeea" vertical={false} />
            <XAxis dataKey="mes" interval={0} tick={{ fontSize: 11, fill: "#71717a" }} axisLine={{ stroke: "#d4d4d8" }} tickLine={false} />
            <YAxis tickFormatter={k} tick={{ fontSize: 11, fill: "#71717a" }} axisLine={false} tickLine={false} width={44} domain={[0, top]} ticks={ticksTo(top)} />
            <Tooltip content={<CovTip />} cursor={<VerticalCursor />} />
            <Bar dataKey="gastosClamp" stackId="s" fill={COLORS.gas} maxBarSize={40} isAnimationActive={false} />
            <Bar dataKey="sinPos" stackId="s" fill={COLORS.sin} maxBarSize={40} radius={[3, 3, 0, 0]} isAnimationActive={false}>
              <LabelList dataKey="salio" content={<PctLabel rows={data} />} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
